import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory, OverdueCategory, PaymentMethod } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    standalone: true,
    name: 'overdueCategory',
    pure: true
})
export class OverdueCategoryPipe implements PipeTransform {

    constructor(protected translateService: TranslateService) {

    }

    transform(value: OverdueCategory): string {
        switch (value) {
            case OverdueCategory.NO_CATEGORY:
                return "-"
            case OverdueCategory.NO_PAYER:
                return "NO PAYER";
            case OverdueCategory.SLOW_PAYER:
                return "SLOW PAYER";

        }

        return '-';
    }

}
